import React from 'react';
import classNames from 'classnames';
import './RevenueTableCategories.scss';

const RevenueTableCategories = ({ data, headerTitle, from_date }) => {
  const totalRevenue = data.reduce((sum, row) => sum + row.revenue_income, 0);
  const totalLastPeriodRevenue = data.reduce(
    (sum, row) => sum + row.revenue_income_lastmonth,
    0
  );
  let safeOverallPercent = 0;
  if (totalLastPeriodRevenue === 0) {
    safeOverallPercent = totalRevenue > 0 ? 100 : 0; // avoid Infinity
  } else {
    safeOverallPercent =
      ((totalRevenue - totalLastPeriodRevenue) / totalLastPeriodRevenue) * 100;
  }

  // console.log(data);

  return (
    <div className='revenueTableContainer'>
      <table className='revenueTable'>
        <thead>
          <tr>
            <th>{headerTitle[0]}</th>
            <th>{headerTitle[1]}</th>
            <th>{headerTitle[2]}</th>
            <th>{headerTitle[3]}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.account_dashboard_rename}</td>
              <td>
                {/* $
                {row.revenue_income.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} */}

                {row.revenue_income >= 0
                  ? `$${row.revenue_income.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : `($${Math.abs(row.revenue_income).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )})`}
              </td>
              <td>
                {/* $
                {row.revenue_income_lastmonth.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} */}

                {row.revenue_income_lastmonth >= 0
                  ? `$${row.revenue_income_lastmonth.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : `($${Math.abs(row.revenue_income_lastmonth).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )})`}
              </td>
              <td
                className={classNames({
                  positiveChange: row.percentChange >= 0,
                  negativeChange: row.percentChange < 0,
                })}
              >
                {from_date !== 'All' && (
                  <>
                    {row.percentChange >= 0 ? '▲' : '▼'}{' '}
                    {Number(
                      Math.abs(row.percentChange).toFixed(2)
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    %
                  </>
                )}
              </td>
            </tr>
          ))}
          <tr className='totalRow'>
            <td>Total</td>
            <td>
              $
              {totalRevenue.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </td>
            <td>
              $
              {totalLastPeriodRevenue.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </td>
            <td
              className={classNames({
                positiveChange: safeOverallPercent >= 0,
                negativeChange: safeOverallPercent < 0,
              })}
            >
              {from_date !== 'All' && (
                <>
                  {safeOverallPercent >= 0 ? '▲' : '▼'}{' '}
                  {isFinite(safeOverallPercent)
                    ? Math.abs(safeOverallPercent).toFixed(2)
                    : '0.00'}
                  %
                </>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default RevenueTableCategories;
